(function errorsServiceDefinition() {

    'use strict';

    angular.module('ErrorsExtend', ['Messages'])
        .provider('errorsExtend', function errorsProvider() {

            this.$get = ['messages', '$state',
                function (messages, $state) {

                    function processMsj(msj) {
                        return msj;
                    }

                    var svc = Object.create(messages);
                    
                    svc.showWarning = function (text) {
                        messages.show(text, 'warning');
                        return;
                    };

                    svc.showError = function (error) {

                        if (error.status === 403) {
                            messages.show(processMsj(error.data), error.status);
                            $state.go('inicio');
                            return;
                        }

                        if (error.status === 0 || error.status === -1) {
                            messages.show('APIError');
                            $state.go('inicio');
                            return;
                        }

                        if (!error.data) {
                            messages.show(processMsj(error), error.status);
                            return;
                        }

                        if (error.data.modelState) {
                            if (error.data.modelState.error && error.data.modelState.error.length > 0) {
                                messages.show(processMsj(error.data.modelState.error[0]), error.status);
                            } else {
                                for (var key in error.data.modelState) {
                                    if (error.data.modelState.hasOwnProperty(key)) {
                                        messages.show(key.charAt(0).toUpperCase() + key.slice(1), error.status);
                                        break;
                                    }
                                }
                            }
                        } else if (error.data.exceptionMessage) {
                            messages.show(processMsj(error.data.exceptionMessage), error.status, null);
                        } else {
                            messages.show(error.data.key, error.status, error.data.value);
                        }
                    };

                    return svc;
                }
            ];
        });
})();